import CredentialsManagementPage from './CredentialsManagementPage';

export default CredentialsManagementPage;
